import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import { navModule } from './modules/nav';
import { themeModule } from './modules/theme';
import { homeModule } from './modules/home';
import { docsHomeModule } from './modules/docs-home';
import { silkEnvironmentsModule } from './modules/silk-environments';
import { scaffolderFieldsModule } from './modules/scaffolderFields';
import { signInModule } from './modules/signIn';

export default createApp({
  features: [
    catalogPlugin,
    scaffolderPlugin,
    techdocsPlugin,
    searchPlugin,
    navModule,
    themeModule,
    homeModule,
    docsHomeModule,
    silkEnvironmentsModule,
    scaffolderFieldsModule,
    signInModule,
  ],
});
